export class LoginOtpResponse {
    constructor(
        public isError: boolean,
        public message: string,
        public otpErrorCode: string,
        public loginOtp: LoginOtp,
        public userDTO: any
    ) {

    }
}

export class LoginOtp {

    constructor(
        public id?: number,
        public userEmail?: string,
        public token?: string,
        public otp?:string
    ) {

    }

}


export enum OtpErrorCode {
    INVALID_TOKEN = "INVALID_TOKEN",
    INVALID_OTP = "INVALID_OTP",
    OTP_EXPIRED = "OTP_EXPIRED",
    TRY_DURATION_WAIT = "TRY_DURATION_WAIT",
    RESEND_DURATION_WAIT = "RESEND_DURATION_WAIT",
    USER_BLOCKED = "USER_BLOCKED",
    NO_ERROR = "NO_ERROR",
    INVALID_USER = "INVALID_USER",
    RESEND_DURATION_EXCEED = "RESEND_DURATION_EXCEED",
    INVALID_OPERATION = "INVALID_OPERATION",
}

